export default __webpack_public_path__ + "static/media/farming.28b8e9cd.jpg";